import SESSION from '../types/session'
import { getUser, getAuthenticityToken } from '@/tools/session'

const state = {
  isSignedIn: null,
  authenticityToken: null,
  user: {
    isConfirmed: null,
    address: {},
    location: {}
  }
}

getUser().then(user => {
  state.isSignedIn = !!user.id
  getAuthenticityToken().then(token => { state.authenticityToken = token })
  state.user = Object.assign({}, state.user, user)
})

const getters = {
  [SESSION.GETTERS.GET_USER]: state => {
    return state.user
  },
  [SESSION.GETTERS.GET_USER_ADDRESS]: state => {
    return state.user.address
  },
  [SESSION.GETTERS.GET_IS_SIGNED_IN]: state => {
    return state.isSignedIn
  },
  [SESSION.GETTERS.GET_AUTHENTICITY_TOKEN]: state => {
    return state.authenticityToken
  }
}

export default {
  state,
  getters
}
